  /*============Content Cards Controller
      ================================*/
  angular
    .module('vppApp')
    .controller('contentCardsController', contentCardsController);

  contentCardsController.$inject = ['$scope', '$rootScope', '$stateParams', 'vppConfig', '$sce', 'contentCardsFactory', '$httpParamSerializer', '$timeout', '$element', '$q'];

  function contentCardsController($scope, $rootScope, $stateParams, vppConfig, $sce, contentCardsFactory, $httpParamSerializer, $timeout, $element, $q) {
  	
  	$scope.cards;
  	$scope.heading;
  	function getContentCards() {
      contentCardsFactory().then(function(response) {

        $scope.heading = response.heading;
        $scope.cards = response.cards;

      });
    }

    getContentCards();
  }
